import { useFormContext } from 'react-hook-form';

import Box from '@mui/material/Box';

import ColorCell from '../../../../../Table/TableCell/DataGrid/ColorCell';

export function RenderColorReadMode({ name, label }) {
  'use memo';

  const { getValues } = useFormContext();

  return (
    <Box paddingX={'14px'}>
      <Box sx={{ typography: 'subtitle2' }}>
        <label>{label}</label>
      </Box>
      <Box sx={{ typography: 'h4' }}>
        <ColorCell value={getValues(name)} />
      </Box>
    </Box>
  );
}
